import React from 'react'
import { Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import BasePackageForm from '../BasePackageForm'

const ProfessionalPackageEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.professionalpackages.editPackage'}>
      <Edit>
        <BasePackageForm entity="professionals" />
      </Edit>
    </SectionWrapper>
  )
}

export default ProfessionalPackageEdit
